import { render, staticRenderFns } from "./BisgrafCheckbox.vue?vue&type=template&id=7bf1865c&scoped=true&"
import script from "./BisgrafCheckbox.vue?vue&type=script&lang=js&"
export * from "./BisgrafCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./BisgrafCheckbox.vue?vue&type=style&index=0&id=7bf1865c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf1865c",
  null
  
)

export default component.exports